export default __webpack_public_path__ + "static/media/ec.43540b4e.svg";